// extracted by mini-css-extract-plugin
module.exports = {"noReturn":"cruiseroute_noReturn__Ja9YU","bold":"cruiseroute_bold__wH5vA","btn":"cruiseroute_btn__F3GNK"};